import { Expose } from 'class-transformer';

export interface IFirmAuth {
  firmId: number;
  role: string;
  id: number;
}

export interface IFirmModel {
  id: number;
  title: string;
  country: string;
  address: string;
  currency: string;
  longitude: string;
  latitude: string;
}

export class FirmModel {
  @Expose({ name: 'id' })
  id!: number;
  @Expose({ name: 'title' })
  title!: string;
  @Expose({ name: 'country' })
  country!: string;
  @Expose({ name: 'address' })
  address!: string;
  @Expose({ name: 'currency' })
  currency!: string;
  @Expose({ name: 'longitude' })
  longitude!: string;
  @Expose({ name: 'latitude' })
  latitude!: string;
  @Expose({ name: 'price_provider' }) priceProvider!: EPriceSystem;
  @Expose({ name: 'markup' })
  markup?: number;

  @Expose({ name: 'role' })
  role!: string;

  selected = false;
}

export enum CountryIdEnum {
  Norway = 'norway',
  Germany = 'germany',
  Sweden = 'sweden',
  USA = 'usa',
  UnitedKingdom = 'united kingdom',
}

export const countryHash = {
    norway: { name: 'no', currency: 'nok' },
    germany: { name: 'de', currency: 'eur' },
    sweden: { name: 'se', currency: 'sek' },
    usa: { name: 'us', currency: 'usd' },
    ['united kingdom']: { name: 'gb', currency: 'gbp' },
  };

export const listOfCountries = [
  { id: CountryIdEnum.Norway, country: 'Entity.Norway' },
  { id: CountryIdEnum.Germany, country: 'Entity.Germany' },
  { id: CountryIdEnum.Sweden, country: 'Entity.Sweden' },
  { id: CountryIdEnum.USA, country: 'USA' },
  { id: CountryIdEnum.UnitedKingdom, country: 'Entity.UK' },
];

export enum EPriceSystem {
  Simple = 'default',
  MarkUp = 'vat',
}

export interface ICreateFirm {
  title: string;
  country: string;
  currency: string;
  price_provider: EPriceSystem;
  address?: string;
  latitude?: string;
  longitude?: string;
  markup?: number;
  vat?: number;
}
